export default __webpack_public_path__ + "static/media/selecta_mobile@2x.e5812828.jpg";